

import { useDispatch } from 'react-redux';
import { store } from 'Store';
import { http } from 'Utils';
import { ERROR_MESSAGES, SPECIAL_CHARS_PATTERN } from 'Utils/constants';
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import Col from 'react-bootstrap/Col';
import {Button, Collapse, Dropdown, Fade, ListGroup} from 'react-bootstrap';
import {TextButton } from 'Components/Button';
import { useEffect, useRef, useState } from 'react';
import NavigationBar from './NavigationBar';
import SearchInput from './SearchInput';
import { ReportOffOutlined } from '@mui/icons-material';
import { highlightApi } from 'Utils/highlightUtil';
import { Fragment } from 'react';
import { config } from 'Utils/config';

function SearchBar ({
    verResults, 
    setVerResults, 
    resultsRef, 
    activeDrop, 
    setActiveDrop, 
    subOnly, 
    setSubOnly, 
    handleChange, 
    resultCategories, 
    setResultCategories, 
    resultIndex, 
    setResultIndex, 
    searchTerm, 
    setSearchTerm, 
    activeSearch, 
    setActiveSearch,
    isSticky, 
    setFocusKeyword, 
    setHighlighted, 
    categoryId, 
    moduleKey
}) {
    const dispatch = useDispatch();

    //If search results dropdown is visible
    const [showFloatingDropdown, setShowFloatingDropdown] = useState(false); 

    const [totalResults, setTotalResults] = useState(0);
    const [totalVersions, setTotalVersions] = useState(0);
    const [suggestions, setSuggestions] = useState([]);
    const [noResultsSearchTerm, setNoResultsSearchTerm] = useState(null);

    // Exit search feature button
    const exitBtn = useRef(null);   
    const dropdownRef = useRef(null);
    const searchDropRef = useRef(null);
    const floatingSearchContainerRef = useRef(null);
    
    //If a component in static search is in focus, or floating search
    const [isFocusBase, setIsFocusBase] = useState(true); 
    
    // Indicates if open search results button has focus
    const [openBtnFocus, setOpenBtnFocus] = useState(false);
    const openBtnBase = useRef(null);   // STATIC open search results button
    const openBtn = useRef(null);   // STICKY open search results button

    // Indicates if search input field has focus
    const [searchBarFocus, setSearchBarFocus] = useState(false); 
    const searchBarBase = useRef(null); // STATIC search bar input
    const searchBar = useRef(null); // STICKY search bar input

    // Indicates if search button has focus
    const [searchBtnFocus, setSearchBtnFocus] = useState(false); 
    const searchBarBtnBase = useRef(null);  // STATIC search button
    const searchBarBtn = useRef(null);  // STICKY search button
    
    const KEY_NAME_ESC = 'Escape';
    const KEY_EVENT_TYPE = 'keydown';


    // Handle term highlighting in search results dropdown

    useEffect(()=>{
        config.isDebugEnabled && console.log(resultCategories, activeSearch,searchTerm,resultsRef, resultsRef.current);
        
        if(activeSearch==false){
            CSS.highlights.clear();
        }
        else{
            if(searchTerm!="" && resultsRef!=null && resultsRef.current!=null){
                highlightApi(resultsRef, searchTerm, "search-results-repo-drop",null,null);
            }
        }
    },[resultCategories, resultsRef.current])

    // Add listeners for escape key and tabbing
    // - Close search results dropdown on escape
    // - Keep focus trapped within floating search container when tabbing 
    useEffect(() => {
        if(showFloatingDropdown==true){
            const modalElement = floatingSearchContainerRef.current;
            const firstElement = openBtn.current;
            const lastElement = exitBtn.current;

            const handleEscKey = (event) => {
                if (event.key === KEY_NAME_ESC) {
                    setShowFloatingDropdown(false);
                }
            };
            const handleTabKeyPress = (event) => {
                if (event.key === "Tab") {
                    if (event.shiftKey && document.activeElement === firstElement) {
                        event.preventDefault();
                        lastElement.focus();
                    } 
                    else if (!event.shiftKey && document.activeElement === lastElement) {
                        event.preventDefault();
                        firstElement.focus();
                    }
                }
            };

            modalElement.addEventListener(KEY_EVENT_TYPE, handleTabKeyPress);
            modalElement.addEventListener(KEY_EVENT_TYPE, handleEscKey);
            return () => {
                modalElement.addEventListener(KEY_EVENT_TYPE, handleTabKeyPress);
                modalElement.removeEventListener(KEY_EVENT_TYPE, handleEscKey);
            };
        }
    }, [showFloatingDropdown, setShowFloatingDropdown]);

    
    const getSearchData = async (keyword,psoppcSubmissionOnly) => {
        setFocusKeyword(null);
        var url = '/api/cfRepo/search';
        const loginState = store.getState().loginInfo;

        var params = {
            searchTerm:keyword,
            psoppcSubmissionOnly: psoppcSubmissionOnly
        }
        const res = http.post(url, params,{
            headers: {
                "Authorization": "Bearer " + loginState.token
            }
        }).then((response) => {
            if(response != null ){
                var statusCode = response.status;
                if(statusCode != 1){
                    setGlobalErrorStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true, 
                            title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                            msg: response.globalErrorMessageList != null && response.globalErrorMessageList.length>0 ? response.globalErrorMessageList : ERROR_MESSAGES.GENERAL_ERROR.message, 
                            showContactHelp: false 
                        },
                        redirect: {
                            redirect: false, 
                            redirectFirst: false,
                            path: "", 
                            data: {}
                        }
                    });
                }
                else {
                    setActiveSearch(true);

                    if(response.data!=null){
                        var data = response.data;
                        if(data.versionDeMap!=null){
                            var categories = Object.entries(response.data.versionDeMap);
                            setResultCategories(categories);

                            var currentVerResults = categories.filter((c)=>{
                                config.isDebugEnabled && console.log("category", c);

                                var currentModuleResults = c[1].filter((m)=>{
                                    config.isDebugEnabled && console.log(m.deModuleId,moduleKey,m.deVersionId,categoryId,m);
                                    
                                    if(m.deModuleId == moduleKey && m.deVersionId==categoryId){
                                        return true;
                                    }
                                    else{
                                        return false;
                                    }
                                })

                                config.isDebugEnabled && console.log("currentModuleResults",currentModuleResults);
                                if(currentModuleResults.length>0){
                                    return currentModuleResults;
                                }
                                else{
                                    return false;
                                }
                            })
                            config.isDebugEnabled && console.log("currentVerResults",currentVerResults);
                            setResultIndex(-1);
                        }
                        else{
                            setResultCategories([]);
                            setNoResultsSearchTerm(keyword);
                            setResultIndex(-1);
                        }
                        setSuggestions(data.spellCheckSuggestions);
                        setTotalResults(data.totalCount!=null ? data.totalCount : 0);
                        setTotalVersions(data.versionCount!=null ? data.versionCount : 0);
                    }
                } 
            }
            else{
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true, 
                        title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                        msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                        showContactHelp: true 
                    },
                    redirect: {
                        redirect: false, 
                        redirectFirst: false,
                        path: "", 
                        data: {}
                    }
                });
                setActiveSearch(false);
                setShowFloatingDropdown(false);
            }
        }).catch(function (error) {
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true, 
                    title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                    showContactHelp: true 
                },
                redirect: {
                    redirect: false, 
                    redirectFirst: false,
                    path: "", 
                    data: {}
                },
                error: error
            });
        });
        return res;
    };

    // When PSOPPC only filter changes
    useEffect(()=>{
        if(searchTerm!="" && activeSearch==true){
            getSearchData(searchTerm, subOnly);
        }
    },[subOnly])


    // Transfer focus from sticky search element to static search element or vice versa
    useEffect(()=>{
        //console.log(activeSearch, isSticky, showFloatingDropdown, isFocusBase, openBtnFocus, searchBarFocus, searchBtnFocus, searchDropRef.current, searchBarBtn.current, searchBar.current);
        // If sticky search bar
        if((isSticky==true && activeSearch==true) || (activeSearch==true && showFloatingDropdown==true)){
            //NOT to focus on static search bar element
            setIsFocusBase(false);
            //console.log(openBtnFocus, searchBarFocus, searchBtnFocus);
            if(openBtnFocus || searchBarFocus || searchBtnFocus){
                //console.log(openBtnFocus, searchBarFocus, searchBtnFocus);
                const timer = setTimeout(() => {
                    if(openBtnFocus==true){
                        if(openBtn.current){
                            (openBtn.current).focus({
                                preventScroll: true
                            });
                        }
                    }
                    if(searchBarFocus==true){
                        if(searchBar.current){
                            (searchBar.current).focus({
                                preventScroll: true
                            });
                        }
                    }
                    if(searchBtnFocus==true){
                        if(searchBarBtn.current){
                            (searchBarBtn.current).focus({
                                preventScroll: true
                            });
                        }
                    }
                }, 150); // Delay for Bootstrap slide transition
                return () => clearTimeout(timer);  
            }
        }
        // If no sticky search bar
        else{
            if(openBtnFocus==true){
                if(openBtnBase.current){
                    (openBtnBase.current).focus({
                        preventScroll: true
                    });
                }
            }
            if(searchBarFocus==true){
                if(searchBarBase.current){
                    (searchBarBase.current).focus({
                        preventScroll: true
                    });
                }
            }
            if(searchBtnFocus==true){
                if(searchBarBtnBase.current){
                    (searchBarBtnBase.current).focus({
                        preventScroll: true
                    });
                }
            }
        }
    },[isSticky, showFloatingDropdown, isFocusBase, openBtnFocus, searchBarFocus, searchBtnFocus, searchDropRef.current, dropdownRef.current])

    const exitSearch = () => {
        setActiveSearch(false);
        setShowFloatingDropdown(false);
        setSearchTerm("");
        setHighlighted({});
        setActiveDrop(null);
        setResultCategories(null);
        setVerResults([]);
        setResultIndex(-1);
        setFocusKeyword(null);
    }

    return (
        <div className="">     
            {/* The static search bar element container at top of page */}
            <div  id="non-floating-search-container" className={ "non-floating"}>
                <Col  id="fixed-search-controls" className=" z-3  d-flex justify-content-start justify-content-md-end ">
                    <div className={"search-div-dropdown col-12 modal-open"}>
                        <div className="d-flex flex-row gap-4 flex-wrap flex-lg-nowrap">
                            {/* Search bar text input and button */}
                            <SearchInput
                                setShowFloatingDropdown={setShowFloatingDropdown}
                                setSearchTerm={setSearchTerm}
                                searchTerm={searchTerm}
                                getSearchData={getSearchData}
                                isSticky={isSticky}
                                itemLocation={'base'}
                                setIsFocusBase={setIsFocusBase}
                                setSearchBarFocus={setSearchBarFocus}
                                setSearchBtnFocus={setSearchBtnFocus}
                                searchBar={searchBarBase}
                                searchBtn={searchBarBtnBase}
                                subOnly={subOnly}
                                exitSearch={exitSearch}
                            >
                            </SearchInput>
                        </div>
                        {
                            activeSearch==true
                            ?
                                // Navigation Bar that holds search result navigation arrows and menu button
                                <NavigationBar
                                    setShowFloatingDropdown={setShowFloatingDropdown}
                                    showFloatingDropdown={showFloatingDropdown}
                                    resultIndex={resultIndex}
                                    setResultIndex={setResultIndex}
                                    totalResults={totalResults}
                                    totalVersions={totalVersions}
                                    itemLocation={'base'}
                                    setIsFocusBase={setIsFocusBase}
                                    setOpenBtnFocus={setOpenBtnFocus}
                                    openBtn={openBtnBase}
                                    setFocusKeyword={setFocusKeyword}
                                    setActiveDrop={setActiveDrop}
                                    activeDrop={activeDrop}
                                    handleChange={handleChange}
                                    resultCategories={resultCategories}
                                    categoryId={categoryId}
                                    verResults={verResults}
                                    setVerResults={setVerResults}
                                ></NavigationBar>
                            :   null
                        }
                    </div>
                </Col>              
            </div> 
            
            {/* 
                The sticky search bar element that stays with user, and contains result dropdown 
                - only shown for active search when showFloatingDropdown is true or when isSticky is true (when scrolled past static search bar)
            */}
            <div 
                ref={floatingSearchContainerRef} 
                id="floating-search-container" 
                className={(isSticky==true && activeSearch==true) || (activeSearch==true && showFloatingDropdown==true) ? " position-fixed top-0 start-0 w-100 " : "d-none"}
            >
                <Col id="fixed-search-controls" className=" z-3  d-flex justify-content-start justify-content-md-end shadow2">
                    <Dropdown  
                        autoClose="outside"
                        show={showFloatingDropdown} 
                        ref={dropdownRef}
                        className={"search-div-dropdown col-12 modal-open"}
                    >
                        {
                            activeSearch==true
                            ?
                                // Navigation Bar that holds search result navigation arrows and menu button
                                <NavigationBar
                                    setShowFloatingDropdown={setShowFloatingDropdown}
                                    showFloatingDropdown={showFloatingDropdown}
                                    resultIndex={resultIndex}
                                    setResultIndex={setResultIndex}
                                    totalResults={totalResults}
                                    totalVersions={totalVersions}
                                    itemLocation={'fixed'}
                                    setIsFocusBase={setIsFocusBase}
                                    setOpenBtnFocus={setOpenBtnFocus}
                                    openBtn={openBtn}
                                    setFocusKeyword={setFocusKeyword}
                                    setActiveDrop={setActiveDrop}
                                    handleChange={handleChange}
                                    resultCategories={resultCategories}
                                    categoryId={categoryId}
                                    verResults={verResults}
                                    setVerResults={setVerResults}
                                    activeDrop={activeDrop}
                                ></NavigationBar>
                            :   null
                        }
                        
                        {/* Contains floating search input and search results list, collapse animation on open and close */}
                        <Collapse 
                            in={showFloatingDropdown} 
                            className={" g-0 search-dropdown m-0 w-100 rounded-0 p-0 " + (isSticky==true ? " position-relative " : " position-absolute ")} 
                            align="start"
                        >
                            <div>
                                <div ref={searchDropRef} id="dropdown-search"></div>
                                {/* Search bar text input and button */}
                                <SearchInput
                                    setShowFloatingDropdown={setShowFloatingDropdown}
                                    setSearchTerm={setSearchTerm}
                                    searchTerm={searchTerm}
                                    getSearchData={getSearchData}
                                    isSticky={isSticky}
                                    itemLocation={'fixed'}
                                    setIsFocusBase={setIsFocusBase}
                                    setSearchBarFocus={setSearchBarFocus}
                                    setSearchBtnFocus={setSearchBtnFocus}
                                    searchBar={searchBar}
                                    searchBtn={searchBarBtn}
                                    subOnly={subOnly}
                                    exitSearch={exitSearch}
                                >
                                </SearchInput>
                                {
                                    activeSearch==true
                                    ? 
                                        // Search results container
                                        <Col className="d-flex flex-column results-box ">
                                            <div className="results-container">
                                                    { 
                                                        resultCategories != null 
                                                        ? 
                                                            <Fragment>
                                                                {
                                                                    // When there are no search results
                                                                    resultCategories.length == 0 
                                                                    ?   <div
                                                                            className="body semibold color-base-black d-flex flex-column align-items-center pt-8px pb-12px px-16px px-sm-32px gap-10px" 
                                                                            key={"none found"}
                                                                        >
                                                                            <div className="d-flex flex-column align-items-center gap-10px py-3">
                                                                                <ReportOffOutlined/>
                                                                                <div className="text-center">
                                                                                    <div className="body bold mb-0">No results for "{noResultsSearchTerm}"</div>
                                                                                    <p className="body regular mb-0">No data elements matched across all versions. Try a shorter term, a DE number, or remove the selected filter (if applicable).</p>
                                                                                </div>
                                                                            </div>
                                                                            {
                                                                                (suggestions!=null && suggestions.length>0) || subOnly==true
                                                                                ?
                                                                                    <div className="d-flex flex-row flex-wrap no-result-choices gap-3 gap-md-4 row-gap-2 py-4px justify-content-center">
                                                                                        {/* If there are search suggestions given */}
                                                                                        {
                                                                                            suggestions!=null
                                                                                            ?   
                                                                                                suggestions.map((s)=>{
                                                                                                    return (
                                                                                                        <TextButton
                                                                                                            variant="comp-outline"
                                                                                                            content={`Try "` +s + `"`}
                                                                                                            className="body semibold"
                                                                                                            onClick={()=>{
                                                                                                                setSearchTerm(s);
                                                                                                                getSearchData(s, subOnly);
                                                                                                            }}
                                                                                                        >
                                                                                                        </TextButton>
                                                                                                    )
                                                                                                })
                                                                                            :   null
                                                                                        }
                                                                                        {/* If the PSOPPC only filter is applied */}
                                                                                        {
                                                                                            subOnly==true
                                                                                            ?   <TextButton
                                                                                                    variant="comp-outline"
                                                                                                    content={"Remove PSOPPC only filter"}
                                                                                                    className="body semibold"
                                                                                                    onClick={()=>{
                                                                                                        setSubOnly(false);
                                                                                                        getSearchData(searchTerm, false);
                                                                                                    }}
                                                                                                >
                                                                                                </TextButton>
                                                                                            :   null
                                                                                        }
                                                                                    </div>
                                                                                :   null
                                                                            }
                                                                        </div>
                                                                    :   
                                                                        // When there are results
                                                                        <ListGroup className="w-100" ref={resultsRef}>
                                                                            {
                                                                                // Go through each version's results
                                                                                resultCategories.map((c) => {
                                                                                    return (
                                                                                        <Fragment key={"search-result-version-results-"+ c[1][0].deVersionId}>
                                                                                            {/* Add version header to list */}
                                                                                            <ListGroup.Item
                                                                                                action={false}
                                                                                                className={((c[1][0].deVersionId) == categoryId ? "activeDropdownVer" : "") +  " category-name body semibold color-primary-jeanblue d-flex flex-row justify-content-between"}
                                                                                                key={"search-result-version-"+ c[1][0].deVersionId}
                                                                                            >
                                                                                                {c[0]} 
                                                                                            </ListGroup.Item>

                                                                                            {/* Add search result list buttons for current version */}
                                                                                            {
                                                                                                c[1].map((m,i) => {
                                                                                                    return (
                                                                                                        <ListGroup.Item 
                                                                                                            as={Button}
                                                                                                            action 
                                                                                                            active={(m.deIdentifier) === activeDrop}
                                                                                                            className="result-text d-flex flex-row justify-content-between"
                                                                                                            eventKey={m.deIdentifier} 
                                                                                                            key={"search-result-"+m.deIdentifier}
                                                                                                            onClick={()=>{
                                                                                                                setResultIndex(i);
                                                                                                                setFocusKeyword(null);
                                                                                                                setActiveDrop(m.deIdentifier);
                                                                                                                handleChange(m.deVersionId, m.deModuleId, m);
                                                                                                                setShowFloatingDropdown(false);
                                                                                                            }}
                                                                                                        >
                                                                                                            {m.deCode} - {m.deName}
                                                                                                        </ListGroup.Item>
                                                                                                    );
                                                                                                })
                                                                                            }
                                                                                        </Fragment>
                                                                                    );
                                                                                })
                                                                            }
                                                                        </ListGroup>
                                                                }
                                                            </Fragment>
                                                        :   null
                                                    }
                                            </div>

                                            {/* Button to exit search feature completely */}
                                            <div className="w-100 d-flex exit-search-container">
                                                <TextButton
                                                    ref={exitBtn}
                                                    content="Exit Search"
                                                    variant="comp-outline"
                                                    size="lg"
                                                    className="exit-search w-100 m-2 "
                                                    onClick={()=>{
                                                        exitSearch();
                                                    }}
                                                ></TextButton>
                                            </div>
                                        </Col>
                                    :   null
                                }
                            </div>
                        </Collapse>
                    </Dropdown>
                </Col>              
              
                {/* Backdrop for when search results dropdown is expanded */}
                <Fade 
                    appear={true} 
                    mountOnEnter={true} 
                    unmountOnExit={true} 
                    className={showFloatingDropdown==true ? "offcanvas-backdrop show" : "offcanvas-backdrop hide"} 
                    in={showFloatingDropdown==true ? true : false} 
                    onClick={()=>{
                        setShowFloatingDropdown(false);
                    }}
                >
                    <div></div>
                </Fade>
            </div> 
        </div>
    );
}

export default SearchBar;
